import lazyLoading from './lazyLoading'
import schedulerResource from '../../../views/scheduler/resources/schedulerResource'
import SiteResourceFactory from "../../../views/projects/resources/SiteResourceFactory.js";
const businessSiteResource = SiteResourceFactory.create('business');

export default {
  name: 'Scheduler',
  system: 'scheduler',
  meta: {
    auth: true,
    label: 'Scheduler',
    icon: 'calendar',
    expanded: false
  },
  children: [
    {
      name: 'AdactiveAdmin',
      path: '/scheduler/adactive/admin',
      component: lazyLoading('scheduler/admin'),
      meta: {
        label: 'Admin Adactive',
        expanded: false
      }
    },
    {
      name: 'SeomaticAdmin',
      path: '/scheduler/seomatic/admin',
      component: lazyLoading('scheduler/admin'),
      props: {
        listCustomers: schedulerResource.listInjectedSeomaticCustomers.bind(schedulerResource),
        listKeywords: businessSiteResource.listOriginalKeywords.bind(businessSiteResource)
      },
      meta: {
        label: 'Admin Seomatic',
        expanded: false
      }
    },
    {
      name: 'Employee',
      path: '/scheduler/employee',
      component: lazyLoading('scheduler/employee'),
      meta: {
        label: 'Scheduler Employee',
        expanded: false
      }
    }, {
      name: 'backlinksPlanner',
      auth: 'admin',
      path: '/scheduler/planner',
      component: lazyLoading('scheduler/planner', true),
      meta: {
        label: 'BacklinkSites Planner',
        icon: 'fa-wrench',
        expanded: false
      },
    }
  ]
}
